// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2031":"d7edf80e","5459":"f8465bd8","5645":"f33115dc","6219":"f33115dc"}[chunkId] + ".chunk.css";
};